<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="" style="min-height: 352px; width: 100%;">
      <b-row class="p-0 m-0">
        <b-col cols="5" class="thtable p-0">Tratamiento</b-col>
        <b-col class="thtable text-center">Unidades dentales</b-col>
        <b-col class="thtable text-center">Total</b-col>
        <b-col cols="1" class="thtable"></b-col>
      </b-row>
      <hr class="m-0" style="margin-top: 3px; border: 0; height: .1vh; background: #D6E7F3;">

      <div class="scrollable-container no-horizontal-scroll mt-2" style="height: 58vh">
        <div class="" v-for="(me, index) in tratamientosInversion.filter(ti => ti.agregadoACarrito)" :key="index">
          <b-row class="p-0 m-0">

            <b-col cols="5" class="d-flex align-items-center justify-content-start p-0">
              <div v-if="resumenCardSeleccionado === index" class="d-flex mb-2 justify-content-start" style="min-height: 20px;" @click="resumenCardSeleccionado = null" v-b-toggle="'collapseCars-'+index">
                <em v-if="me.idKitTratamiento == null" class="dienteCepillo" style="margin-top: -7%;"></em>
                <em v-else class="kit_svg" style="margin-top: -7%;"></em>
                <p  v-if="me.idKitTratamiento == null" class="m-0" style="font-size: .7em;">{{ me.tratamiento }}</p>
                <p v-else class="m-0" style="font-size: .7em;">{{ me.nombreKit }}</p>
              </div>
              <div v-else class="d-flex mb-2 justify-content-start w-100" style="min-height: 20px;" @click="resumenCardSeleccionado = index" v-b-toggle="'collapseCars-'+index">
                <em v-if="me.idKitTratamiento == null" class="dienteCepillo" style="margin-top: -7%;"></em>
                <em v-else class="kit_svg" style="margin-top: -7%;"></em>
                <p v-if="me.idKitTratamiento == null" class="m-0" style="font-size: .7em; margin-top: -10px;">{{ me.tratamiento }}</p>
                <p v-else class="m-0" style="font-size: .7em;">{{ me.nombreKit }}</p>
              </div>
            </b-col>
            <b-col class="text-center">
              <p v-if="me.idKitTratamiento == null" style="font-size: .7em;">{{ me.dientesAgrupadosCarrito.toString() }}</p>
              <p v-else style="font-size: .7em;">{{ me.tratamientos[0].diente }}</p>
            </b-col>
            <b-col class="text-center">
              <p style="font-size: .7em;">{{me.montoAceptadoInversion | monedaEntero}}</p>
            </b-col>
            <b-col cols="1" class="text-left" >
                <div style="display: inline-flex; margin-left: -26px"  >
                    <em  v-if="resumenCardSeleccionado === index"
                         @click="resumenCardSeleccionado = null" v-b-toggle="'collapseCars-'+index"
                         class="chevronUp_gray_circle"
                         style="width: 22px"
                    ></em>

                    <em v-else  @click="resumenCardSeleccionado = index" v-b-toggle="'collapseCars-'+index"
                        class="chevron_gray_circle"
                        style="width: 22px"
                    ></em>

                  <em class="trash_svg"
                      @click="quitarDeInversion(index, me, true)"
                      v-b-tooltip.hover.top.v-light
                      title="Quitar del carrito"
                      v-if="me.permiteQuitarCarrito == null || !me.permiteQuitarCarrito"
                  ></em>
                </div>


            </b-col>
          </b-row>
         
          <b-collapse :id="'collapseCars-'+index" accordion="my-accordion-resumen" role="tabpanel">
            <div class="d-flex justify-content-center">
              <b-card-body style="border: 1px solid #d6e7f3; border-radius: 16px; width: 90%;">
                <b-table-simple >
                  <b-thead class="columnasTablaSinColor text-center">
                        <b-tr>
                          <b-th class="thtableCollapse" v-if="me.tratamientos.filter(t => t.agregadoACarrito)[0].idKitTratamiento === null">Diente</b-th>
                          <b-th class="thtableCollapse" v-else>Tratamiento</b-th>
                          <b-th class="thtableCollapse">Cantidad</b-th>
                          <b-th class="thtableCollapse" v-if="me.idKitTratamiento   == null && (me.permiteQuitarCarrito == null || !me.permiteQuitarCarrito)">Quitar OD</b-th>
                          <b-th class="thtableCollapse"></b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(lista, ind1) in me.tratamientos.filter(t => t.agregadoACarrito)" :key="ind1" class="text-center">
                          <b-td class="thtableCollapse-body" v-if="lista.idKitTratamiento === null">{{ lista.diente }}</b-td>
                          <b-td class="thtableCollapse-body" v-else >{{ lista.tratamiento }}</b-td>
                          <b-td v-if="lista.idKitTratamiento === null" class="d-flex justify-content-center thtableCollapse-body">
                            <b-form-input
                                class="redondeo"
                                style="font-size: 1em; width: 56px; height: 25px;"
                                id="cantidad"
                                @keypress="onlyNumber($event)"
                                @change="recalcularPrecioUnitario(me, lista)"
                                @keyup="validarCantidad(lista.cantidadAceptada, lista)"
                                onpaste="return false;"
                                type="number"
                                :min="1"
                                :max="lista.cantidadMaxima"
                                pattern="^[0-9]+"
                                v-model.number="lista.cantidadAceptada"
                                :disabled="me.permiteQuitarCarrito != null && me.permiteQuitarCarrito"
                            ></b-form-input>
                            <p class="m-0 mt-1 ml-2" >de {{lista.cantidadMaxima}}</p>
                          </b-td>
                          <b-td v-else class="d-flex justify-content-center thtableCollapse-body">
                            <p class="m-0 mt-1 ml-2">{{lista.cantidadMaxima}}</p>
                          </b-td>

                          <b-td v-if="lista.idKitTratamiento == null ">
                            <em class="trash_svg" style="cursor: pointer; width: 18px;"
                                v-if="me.permiteQuitarCarrito == null || !me.permiteQuitarCarrito" 
                                @click="quitarDeInversion(ind1, lista, false, me)"
                            ></em>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-card-body>
            </div>  
          </b-collapse>
        </div>
        <div>
          
        </div>
      </div>
    </div>


    <b-row class="w-100 m-0 p-0" style="margin-top: 4% !important;">
      <b-col cols="11" class="p-0">
        <!--  -->
        <div v-if="nombrePlan != null">
          <span class="text">Gracias a tu plan </span> <span class="text"> {{nombrePlan}} </span> <span class="text"> ahorrarás: </span>
          <span class="text-2">{{ montoAhorradoPlan | monedaEntero}}</span>
        </div>
        <!--  -->
        <div v-if="montoAhorradoPromo !== 0">
          <span class="text">Resumen de Promociones </span>
          <span class="text-2">{{ montoAhorradoPromo | monedaEntero }}</span>
        </div>
      </b-col>
      <b-col cols="1" class="d-flex justify-content-end align-items-center p-0 m-0">
        <em class="calculadora" 
            @click="showModal"
        ></em>
      </b-col>
    </b-row>
    <div class="inv-total d-flex justify-content-between align-items-center p-2 mt-3">
      <p class="m-0">Inversión total</p>
      <p class="m-0">{{inversionTotal | monedaEntero}}
      </p>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <b-button class="p-2" variant="outline-info" pill style="background-color: #3F9BD3; color: #FFFFFF; font-size: .85em; min-width: 120px;" @click="aceptarPtiOpcion()"
      > Continuar</b-button>
    </div>



    <b-modal ref="my-calculadora" size="lg" hide-footer hide-header no-close-on-esc no-close-on-backdrop>

      <CalculadoraPF
               :totalInversion="inversionTotal"
               :tratamientosInversion="tratamientosInversion"
               :idPaciente="idPaciente"
               @hideModal="hideModal"
      />
    </b-modal>
    <b-modal
        size="md"
        v-model="mostrarContactoPaciente"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
    >
      <template #modal-title>
        <div>
          <em class="correoAzul" style="font-size: 12px; width: 19px; margin-bottom: -4px;"></em>
          <span style="color:#044169; font-weight: 600; font-size: 12px" > Medio de contacto del paciente</span>
        </div>
      </template>
      <ContactoPacienteV5
          :loading="loading"
          :idPaciente="idPaciente"
          @guardarOpcionAceptada="guardarOpcionAceptada"
      ></ContactoPacienteV5>
    </b-modal>

    <b-modal
        size="md"
        v-model="mostrarMotivosRechazoPaciente"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
    >
      <template #modal-title>
        <div>
          <em class="engrane_azul_svg" style="font-size: 16px; width: 18px; margin-bottom: -4px;"></em>
          <span style="color:#044169; font-weight: 600; font-size: 12px" > Decisión del paciente sobre el pti</span>
        </div>
      </template>
      <b-card class="cardContacto" >
        <span style="font-size: 12px">¿Porque esta rechazando? </span>
        <b-form-select
            style="font-size: 12px"
            v-model="respuestaM2"
            :options="listaMotivosPti.filter(f => f.idEstatusM2 === 2)"
            value-field="idRespuestaM2"
            text-field="descripcion"
            :state="respuestaM2 != null"
            required
        >
        </b-form-select>
        <span style="font-size: 12px">Comentarios </span>
        <b-form-textarea
            style="font-size: 12px"
            v-model="comentariosRechazoPaciente"
            type="text"
        >
        </b-form-textarea>
        <br/>
        <div class="text-center">
          <b-button  pill variant="outline-info" style="background-color: #0069A9 ;font-size: 12px;"
                      @click="guardarRechazoPtiPaciente()">
            <span style=" color: #FFFFFF" > Aceptar </span>
          </b-button>
          <b-button variant="outline-secondary" pill style="font-size: 12px; margin-left: 3px;" @click="mostrarMotivosRechazoPaciente = false"><span>Cancelar</span></b-button>
        </div>
      </b-card>
    </b-modal>

    <div v-if="mostrarModal" id="modal-container">
      <ConfiguracionPlazosPtiModal :titulo-modal="'Prioridad Clínica'" @cerrar="cerrarModal" :modalAbierto="mostrarModal" :inversionTotal="totalPrioridadParaPlazos" @guardarOpcionAceptada="guardarOpcionAceptada"/>
    </div>

  </div>
</template>

<script>
import ContactoPacienteV5 from "@/version5/negociacion/ContactoPacienteV5";
import CalculadoraPF from "@/version5/negociacion/Calculadora/CalculadoraPF.vue";
import ConfiguracionPlazosPtiModal from "@/components/configuracionPlazosPti/configuracionPlazosPtiModal.vue";
export default {
  name: "TablaResumenInversion",
  components: {ConfiguracionPlazosPtiModal, CalculadoraPF, ContactoPacienteV5},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    inversionTotal: 0,
    resumenCardSeleccionado: null,
    mostrarContactoPaciente: false,
    mostrarMotivosRechazoPaciente: false,
    respuestaM2: null,
    comentariosRechazoPaciente: null,
    idPti: null,
    idSolicitud: null,
    idSolicitudEtapa: null,
    idEtapa: null,
    loaderMax: false,
    montoAhorradoPromo: 0,
    tratamientosInversion: [],
    mostrarModal: false,
    montoAhorradoPromoAux: 0,
  }),
  props: {
    tratamientosInversionProp: Array,
    inversionTotalCarrito: Number,
    llenarArray: Boolean,
    presuntivoSeleccionado: Number,
    montoAhorradoPromoProp: Number,
    idPaciente: Number,
    contactosPaciente: Array,
    listaMotivosPti: Array,
    loading: Boolean,
    presuntivos: Array,
    montoAhorradoPlan: Number,
    nombrePlan: String,
    agrupadoPorODProp: Boolean,
    totalPrioridadParaPlazos: Number
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idPti = this.$route.params.idPti;
    this.idSolicitud = this.$route.params.idSolicitud;
    this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa;
    this.idEtapa = this.$route.params.idEtapa;
  },
  watch: {
    inversionTotalCarrito(){
      this.inversionTotal = this.inversionTotalCarrito
    },
    montoAhorradoPromoProp: {
      handler(nuevoValor) {
        //console.log('Objeto nuevoValor:', nuevoValor);
        //console.log('Objeto valorAnterior:', valorAnterior);
        this.montoAhorradoPromo = JSON.parse(JSON.stringify(nuevoValor))
      },
      deep: true
    },
    tratamientosInversionProp: {
      handler(nuevoValor) {
        //console.log('Objeto nuevoValor:', nuevoValor);
        //console.log('Objeto valorAnterior:', valorAnterior);
        this.tratamientosInversion = JSON.parse(JSON.stringify(nuevoValor))
      },
      deep: true
    },
    montoAhorradoPromoAux: {
      handler(nuevoValor) {
        //console.log('Objeto nuevoValor:', nuevoValor);
        //console.log('Objeto valorAnterior:', valorAnterior);
        this.montoAhorradoPromo = JSON.parse(JSON.stringify(nuevoValor))
      },
      deep: true
    },
  },
  methods: {

    guardarRechazoPtiPaciente(){
      this.loaderMax = true;
      this.loading
      const envio = {
        idSolicitud: this.idSolicitud,
        idEstatusM2: 7,
        idRespuestaM2: this.respuestaM2,
        usuarioLogeado: null,
        caja: false,
        idRecibo: null,
        idMedioContactoPaciente: null,
        idSolicitudFlujo: this.idSolicitudEtapa,
        idEtapa: this.idEtapa,
        idPti: this.idPti
      }

      this.$http.post(this.$api + "procesoPtiV5/crearSolicitud/rechazoPtiPaciente", envio).then((response) => {
          if (response.data.data){
            this.loaderMax = false;
          }
          }).finally(() => {
            this.$router.push('/bandeja/seguimiento');
          })
    },
    guardarOpcionAceptada(){
      this.$emit("guardarOpcionAceptada", this.tratamientosInversion, this.inversionTotal);
    },

    obtenerTotalTratamientoCantidad(lstCalcDesc, cantidadAceptada) {
      let sumaTotalCantidadDescuento = 0;
      for (let i=0; i<lstCalcDesc.length && i+1<=cantidadAceptada; i++) {
        let montoDesPlanVale = 0
        if (lstCalcDesc[i].montoDescuentoVale != null) {
          montoDesPlanVale = lstCalcDesc[i].montoDescuentoVale
        } else {
          montoDesPlanVale = lstCalcDesc[i].montoDescuentoPlan;
        }
        // console.info("--recalcularPrecioUnitario ", montoDesPlanVale);
        sumaTotalCantidadDescuento += montoDesPlanVale;
      }
      return sumaTotalCantidadDescuento;
    },

    recalcularPrecioUnitario(me, dientes) {
      dientes.montoUnitarioDespuesDePlanPromo = this.obtenerTotalTratamientoCantidad(
          dientes.lstCalcDesc, dientes.cantidadAceptada);

      this.tratamientosInversion.forEach(ti=> {
        let montos = 0;
        ti.tratamientos.forEach(t => {
          if(t.agregadoACarrito){
          //i++;
          if (t.idPtiTratamiento === dientes.idPtiTratamiento && me.permiteQuitarCarrito == null || !me.permiteQuitarCarrito){

            let montoPromoquitarDiente = t.descuentoPromo != null ?
                (t.descuentoPromo / t.cantidadMaxima) * t.cantidadAceptada: 0;

            if (montoPromoquitarDiente < 0) {
              montoPromoquitarDiente = 0;
            }

            const totalPagar = (t.precioUnitario*t.cantidadAceptada);
            const descuentoPlanyVale=this.obtenerTotalTratamientoCantidad(
                t.lstCalcDesc, t.cantidadAceptada)

            t.montoUnitarioDespuesDePlanPromo = ((totalPagar-descuentoPlanyVale)-montoPromoquitarDiente);

            if (t.montoUnitarioDespuesDePlanPromo < 0) {
              t.montoUnitarioDespuesDePlanPromo = 0;
            }

            console.info("recalcularPrecioUnitario", {
              "lstCalcDesc": t.lstCalcDesc,
              "cantidadAceptada": t.cantidadAceptada,
              "subtotal": t.subtotal,
              "total": t.total,
              "descuentoPromo": t.descuentoPromo,
              "detT": t,
              "dientes.descuentoPromo": dientes.descuentoPromo,
              "dientes.montoPromoDescuento": dientes.montoPromoDescuento,
              "--DESCUENTO-totalPagar": totalPagar,
              "--DESCUENTO-montoPromoquitarDiente": descuentoPlanyVale,
              "--DESCUENTO-PROMO-QUITAR": montoPromoquitarDiente,
              "***montoUnitarioDespuesDePlanPromo": t.montoUnitarioDespuesDePlanPromo,
            });
          }
          montos += t.montoUnitarioDespuesDePlanPromo;
        ti.montoAceptadoInversion = montos;
        }
        })
      })
      this.recalcularPromoDescuentoPorCantidad(dientes);
    },
    recalcularPromoDescuentoPorCantidad(dientes){
      this.tratamientosInversion.forEach(ti => {
        ti.tratamientos.forEach(t => {
          t.montoPromoDescuento =  (t.descuentoPromo / t.cantidadMaxima) * t.cantidadAceptada;
        })
      })

      dientes.montoPromoDescuento = (dientes.descuentoPromo / dientes.cantidadMaxima) * dientes.cantidadAceptada;

      let montoAhorradoDescuento = 0;
      this.tratamientosInversion.forEach(ti => {
        ti.tratamientos.forEach(t => {
          montoAhorradoDescuento += t.montoPromoDescuento
        })
      })
      this.montoAhorradoPromoAux = montoAhorradoDescuento;
    },
    recalcularInversionTotal() {
      this.inversionTotal = this.tratamientosInversion.filter(ti => ti.agregadoACarrito).reduce((total, tratamientos) => total + tratamientos.montoAceptadoInversion, 0)
    },
    actualizarResumenInversion(tratamiento) {
      this.tratamientosInversion.forEach(t => {
        if (tratamiento.idKitTratamiento === null) {
          if (t.idTratamiento === tratamiento.idTratamiento) {


            let montoInversion = 0
            let sumaPromo = 0
            t.tratamientos.forEach(x => {
              if (x.agregadoACarrito) {
                montoInversion += x.total - x.descuentoPromo;
                sumaPromo += x.descuentoPromo;
              }
            })

            t.inversionTotal = montoInversion;
            t.descuentoPromo = sumaPromo;
          }
        }
      })
    },
    aceptarPtiOpcion(){
      /*Caso paciente acepta invertir en tratamientos (tratamientos en carrito)*/
      if (this.tratamientosInversion.length > 0 && this.inversionTotal > 0 ){
        let mensaje = this.presuntivos.length === 1
            ? "<span style='font-size: medium'> Aceptación de pti </span>"
            : this.presuntivoSeleccionado === 1
                ? "<span style='font-size: medium'> Estás aceptando la opción 1 </span>"
                : "<span style='font-size: medium'>Estás aceptando la opción 2 </span>"

        this.$swal.fire({
          icon: "warning",
          title: mensaje,
          html:
              '<div style="text-align:center; font-size: medium">SE ACEPTARÁN Y SE PROGRAMARÁN LOS TRATAMIENTOS QUE HAYAN QUEDADO DENTRO DE PRIORIDAD CLÍNICA,' +
              ' LOS TRATAMIENTOS DEL CARRITO SE ENVIARÁN A CAJA PARA SU PAGO, <span style="font-weight: 600;font-size: medium;">¿DESEA CONTINUAR? </span> </div>' ,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          confirmButtonColor: "#EEBA6D",
          cancelButtonColor: "#595959",
          customClass: {
            confirmButton: "rounded-pill text-small",
            cancelButton: " rounded-pill text-small",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.guardarOpcionAceptada();
          }
        });
      } else {

        this.$swal.fire({
          icon: "warning",
          title: "Carrito Vacío",
          html:
              '<div style="text-align:center; font-size: medium">El carrito está vacío, pero se ' +
              '<span style="font-weight: 600"> programarán los tratamientos dentro de la Prioridad clínica,</span> ' +
              '¿desea continuar?</div>' +
              '<b-button id="open-modal-btn"  size="md" v-b-tooltip.hover.lefttop.v-light variant="outline-info" pill title="Configurar plazos para impresión" style="width: 28px; height: 28px; background-color: #1b81af; border-radius: 50%; border: solid 1px #1b81af; position: absolute;top: 10px; right: 35px;" class="mt-1 d-flex align-items-center justify-content-center"><em class="fa fa-calendar" style="color: #FFF; margin-top: 2px; margin-left: 1px;"/></b-button>' ,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Sí, continuar",
          cancelButtonText: "No, cancelar",
          confirmButtonColor: "#1b81af",
          cancelButtonColor: "#fff",
          customClass: {
            confirmButton: "rounded-pill text-small",
            cancelButton: " rounded-pill text-small border border-secondary text-secondary",
          },
          onOpen: () => {
            document.getElementById("open-modal-btn").addEventListener("click", () => {
              this.$swal.close();
              this.mostrarModal = true;
            });
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.guardarOpcionAceptada();
          }
        });
      }


    },


    importanteRecalcularDescuentoPromo(){
      let montoAhorradoDescuento = 0;
      this.tratamientosInversion.forEach(ti => {
        ti.tratamientos.forEach(t => {
          montoAhorradoDescuento += (t.descuentoPromo / t.cantidadMaxima) * t.cantidadAceptada;
        })
      })
      this.montoAhorradoPromo = montoAhorradoDescuento;

    },


    quitarDeInversion(index, tratamiento, porGrupoTratamientos, tratamientoPadre){
      /*porGrupoTratamientos - true, si se elimina del carrito por grupo de tratamiento
         porGrupoTratamientos - false si se elimina solo uno*/
      if (porGrupoTratamientos){

        this.montoAhorradoPromo = 0;
        this.inversionTotal = parseInt(this.inversionTotal) - tratamiento.inversionTotal;

        if (this.agrupadoPorODProp){
          this.$emit('activarCarritoPrioridadPorOD', tratamiento, porGrupoTratamientos)
        }else {
          this.$emit('activarCarritoPrioridadClinica', tratamiento, porGrupoTratamientos)

        }

        if (tratamiento.idKitTratamiento === null ){
          this.tratamientosInversion.forEach(ti => {
            if ( ti.idTratamiento === tratamiento.idTratamiento && (ti.idDiente === tratamiento.idDiente)){
              ti.agregadoACarrito = false

              ti.tratamientos.forEach(tr => {
                tr.agregadoACarrito = false;
              //  tr.cantidadAceptada = 0;
              });
            }

          })
        } else {
          this.tratamientosInversion.forEach(ti => {
            if ( ti.idKitTratamiento === tratamiento.idKitTratamiento && tratamiento.tratamientos.length > 0 &&
                (tratamiento.tratamientos[0].idDiente === ti.tratamientos[0].idDiente)){
              ti.agregadoACarrito = false
              ti.tratamientos.forEach(tr => tr.agregadoACarrito = false);
            }

          })
        }


        let montoPromo = 0;
        this.tratamientosInversion.forEach(d => montoPromo += d.descuentoPromo );


      }
      else {
        tratamiento.agregadoACarrito = false;
        tratamientoPadre.montoAceptadoInversion = tratamientoPadre.montoAceptadoInversion-tratamiento.total;



        if (this.agrupadoPorODProp){
          this.$emit('activarCarritoPrioridadPorOD', tratamiento, porGrupoTratamientos)
        }else{
          this.$emit('activarCarritoPrioridadClinica', tratamiento, porGrupoTratamientos)
        }


          tratamientoPadre.dientesAgrupadosCarrito = tratamientoPadre.dientesAgrupadosCarrito.filter(f => f !== tratamiento.diente);

      }
      this.importanteRecalcularDescuentoPromo();
      this.recalcularInversionTotal();

    },



    showModal() {
      this.$refs['my-calculadora'].show()
    },
    hideModal() {
      this.$refs['my-calculadora'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the calculadora has hidden
      this.$refs['my-calculadora'].toggle('#toggle-btn')
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    validarCantidad(input, lista) {
      if (input > lista.cantidadMaxima) {
        this.$swal({
          icon: "warning",
          title: "",
          text: "La cantidad no puede ser mayor de " + lista.cantidadMaxima,
          focusConfirm: false,
          confirmButtonText: "OK",
          confirmButtonColor: "#EEBA6D",
          customClass: {
            confirmButton: "rounded-pill text-small",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            lista.cantidadAceptada = lista.cantidadMaxima;
          }
        });
      }
    },
    cerrarModal() {
      this.mostrarModal = false;
    }
  }
}
</script>

<style scoped>
.scrollable-container {
    overflow-y: auto; 
    max-height: 70vh; 
  }

.thtable {
  font-size: .7em !important;
  font-weight: 600;
}
.thtableCollapse{
  font-size: .8em !important;
  font-weight: 500;
}
.thtableCollapse-body{
  font-size: .7em !important;
  font-weight: normal;
}
.thtable-sm {
  font-size: 9px !important;;
}
.table th, .table td {
  padding: 0.1rem;
  vertical-align: middle;
  border-top: 0px solid #ffffff;
  font-size: 12px;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgb(0 0 0 / 0%);
}
.inv-total{
  font-size: .9em;
  font-weight: bold;
  color: #17A2B8;
  border: 1px solid #90D3DD;
  border-radius: 16px;
  height: 40px;
}
.text {
  position: relative;
  color: #4d4d4d;
  font-size: .75em;
  font-weight: 600;
  line-height: 17.332px;
  text-align: center;
}
.text-2 {
  position: relative;
  color: #7acb7d;
  font-size: .75em;
  font-weight: 600;
  line-height: 21.6px;
  text-align: center;
}
</style>
